// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"210":"5637a6a4","703":"ceda1ca4","787":"6af32225"}[chunkId] + ".chunk.js";
};